module.exports = __webpack_public_path__ + "static/img/Mcvee.1ecb96d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mcvee.jpg
// module id = xeRV
// module chunks = 0